import { render, staticRenderFns } from "./starshop-transaction-routing.vue?vue&type=template&id=083f8269&scoped=true"
import script from "./starshop-transaction-routing.vue?vue&type=script&lang=js"
export * from "./starshop-transaction-routing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f8269",
  null
  
)

export default component.exports